export default {
  ASC: {
    en: 'ASC',
    ja: 'ASC',
    et: 'ASC',
    lt: 'ASC',
    ch: 'ASC',
    ph: 'ASC',
  },
  'Branch Code (Optional)': {
    en: 'Branch Code (Optional)',
    ja: 'Branch Code (Optional)',
    et: 'Branch Code (Optional)',
    lt: 'Branch Code (Optional)',
    ch: 'Branch Code (Optional)',
    ph: 'Branch Code (Optional)',
  },
  'Branch Code must be made of 6 alphanumeric characters': {
    en: 'Branch Code must be made of 6 alphanumeric characters',
    ja: 'Branch Code must be made of 6 alphanumeric characters',
    et: 'Branch Code must be made of 6 alphanumeric characters',
    lt: 'Branch Code must be made of 6 alphanumeric characters',
    ch: 'Branch Code must be made of 6 alphanumeric characters',
    ph: 'Branch Code must be made of 6 alphanumeric characters',
  },
  'Branch created!': {
    en: 'Branch created!',
    ja: 'Branch created!',
    et: 'Branch created!',
    lt: 'Branch created!',
    ch: 'Branch created!',
    ph: 'Branch created!',
  },
  'Branch saved!': {
    en: 'Branch saved!',
    ja: 'Branch saved!',
    et: 'Branch saved!',
    lt: 'Branch saved!',
    ch: 'Branch saved!',
    ph: 'Branch saved!',
  },
  Country: {
    en: 'Country',
    ja: 'Country',
    et: 'Country',
    lt: 'Country',
    ch: 'Country',
    ph: 'Country',
  },
  'Branch Name': {
    en: 'Branch Name',
    ja: 'Branch Name',
    et: 'Branch Name',
    lt: 'Branch Name',
    ch: 'Branch Name',
    ph: 'Branch Name',
  },
  'Branch Info': {
    en: 'Branch Info',
    ja: 'Branch Info',
    et: 'Branch Info',
    lt: 'Branch Info',
    ch: 'Branch Info',
    ph: 'Branch Info',
  },
  'Branch Sign-up Code': {
    en: 'Branch Sign-up Code',
    ja: 'Branch Sign-up Code',
    et: 'Branch Sign-up Code',
    lt: 'Branch Sign-up Code',
    ch: 'Branch Sign-up Code',
    ph: 'Branch Sign-up Code',
  },
  'Cannot delete the branch as it does not exist': {
    en: 'Cannot delete the branch as it does not exist',
    ja: 'Cannot delete the branch as it does not exist',
    et: 'Cannot delete the branch as it does not exist',
    lt: 'Cannot delete the branch as it does not exist',
    ch: 'Cannot delete the branch as it does not exist',
    ph: 'Cannot delete the branch as it does not exist',
  },
  'Country ISO': {
    en: 'Country ISO',
    ja: 'Country ISO',
    et: 'Country ISO',
    lt: 'Country ISO',
    ch: 'Country ISO',
    ph: 'Country ISO',
  },
  'Created Date': {
    en: 'Created Date',
    ja: 'Created Date',
    et: 'Created Date',
    lt: 'Created Date',
    ch: 'Created Date',
    ph: 'Created Date',
  },
  'Danger Zone': {
    en: 'Danger Zone',
    ja: 'Danger Zone',
    et: 'Danger Zone',
    lt: 'Danger Zone',
    ch: 'Danger Zone',
    ph: 'Danger Zone',
  },
  'Delete Branch': {
    en: 'Delete Branch',
    ja: 'Delete Branch',
    et: 'Delete Branch',
    lt: 'Delete Branch',
    ch: 'Delete Branch',
    ph: 'Delete Branch',
  },
  DESC: {
    en: 'DESC',
    ja: 'DESC',
    et: 'DESC',
    lt: 'DESC',
    ch: 'DESC',
    ph: 'DESC',
  },
  'IANA Timezone (Continent/Region)': {
    en: 'IANA Timezone (Continent/Region)',
    ja: 'IANA Timezone (Continent/Region)',
    et: 'IANA Timezone (Continent/Region)',
    lt: 'IANA Timezone (Continent/Region)',
    ch: 'IANA Timezone (Continent/Region)',
    ph: 'IANA Timezone (Continent/Region)',
  },
  'Search Branches': {
    en: 'Search Branches',
    ja: 'Search Branches',
    et: 'Search Branches',
    lt: 'Search Branches',
    ch: 'Search Branches',
    ph: 'Search Branches',
  },
  'New Branch': {
    en: 'New Branch',
    ja: 'New Branch',
    et: 'New Branch',
    lt: 'New Branch',
    ch: 'New Branch',
    ph: 'New Branch',
  },
  'No Results': {
    en: 'No Results',
    ja: 'No Results',
    et: 'No Results',
    lt: 'No Results',
    ch: 'No Results',
    ph: 'No Results',
  },
  'No Code Found': {
    en: 'No Code Found',
    ja: 'No Code Found',
    et: 'No Code Found',
    lt: 'No Code Found',
    ch: 'No Code Found',
    ph: 'No Code Found',
  },
  Save: {
    en: 'Save',
    ja: 'Save',
    et: 'Save',
    lt: 'Save',
    ch: 'Save',
    ph: 'Save',
  },
  Search: {
    en: 'Search',
    ja: 'Search',
    et: 'Search',
    lt: 'Search',
    ch: 'Search',
    ph: 'Search',
  },
  'Sign up code needs to be 6 characters long': {
    en: 'Sign up code needs to be 6 characters long',
    ja: 'Sign up code needs to be 6 characters long',
    et: 'Sign up code needs to be 6 characters long',
    lt: 'Sign up code needs to be 6 characters long',
    ch: 'Sign up code needs to be 6 characters long',
    ph: 'Sign up code needs to be 6 characters long',
  },
  'The sign-up code is already taken': {
    en: 'The sign-up code is already taken',
    ja: 'The sign-up code is already taken',
    et: 'The sign-up code is already taken',
    lt: 'The sign-up code is already taken',
    ch: 'The sign-up code is already taken',
    ph: 'The sign-up code is already taken',
  },
  'You may proceed with creation without custom code': {
    en: 'You may proceed with creation without custom code',
    ja: 'You may proceed with creation without custom code',
    et: 'You may proceed with creation without custom code',
    lt: 'You may proceed with creation without custom code',
    ch: 'You may proceed with creation without custom code',
    ph: 'You may proceed with creation without custom code',
  },
  required: {
    en: 'Please enter {{name}}',
    ja: '{{name}}を入力してください',
    et: 'Palun sisestage {{name}}',
    lt: 'Įveskite {{name}}',
    ch: '请输入{{name}}',
    ph: 'Please enter {{name}}',
  },
  Name: {
    en: 'Name',
    ja: '名称',
    et: 'nimetus',
    lt: 'Name',
    ch: 'Name',
    ph: 'Name',
  },
  'Fail to fetch data': {
    en: 'Fail to fetch data',
    ja: 'Fail to fetch data',
    et: 'Fail to fetch data',
    lt: 'Fail to fetch data',
    ch: 'Fail to fetch data',
    ph: 'Fail to fetch data',
  },
  'Search Classes': {
    en: 'Search Classes',
    ja: 'Search Classes',
    et: 'Search Classes',
    lt: 'Search Classes',
    ch: 'Search Classes',
    ph: 'Search Classes',
  },
  'New Class': {
    en: 'New Class',
    ja: 'New Class',
    et: 'New Class',
    lt: 'New Class',
    ch: 'New Class',
    ph: 'New Class',
  },
  'Class Code (Optional)': {
    en: 'Class Code (Optional)',
    ja: 'Class Code (Optional)',
    et: 'Class Code (Optional)',
    lt: 'Class Code (Optional)',
    ch: 'Class Code (Optional)',
    ph: 'Class Code (Optional)',
  },
  'Class Code must be made of 6 alphanumeric characters': {
    en: 'Class Code must be made of 6 alphanumeric characters',
    ja: 'Class Code must be made of 6 alphanumeric characters',
    et: 'Class Code must be made of 6 alphanumeric characters',
    lt: 'Class Code must be made of 6 alphanumeric characters',
    ch: 'Class Code must be made of 6 alphanumeric characters',
    ph: 'Class Code must be made of 6 alphanumeric characters',
  },
  'Class created!': {
    en: 'Class created!',
    ja: 'Class created!',
    et: 'Class created!',
    lt: 'Class created!',
    ch: 'Class created!',
    ph: 'Class created!',
  },
  'Class saved!': {
    en: 'Class saved!',
    ja: 'Class saved!',
    et: 'Class saved!',
    lt: 'Class saved!',
    ch: 'Class saved!',
    ph: 'Class saved!',
  },
  'Class Name': {
    en: 'Class Name',
    ja: 'Class Name',
    et: 'Class Name',
    lt: 'Class Name',
    ch: 'Class Name',
    ph: 'Class Name',
  },
  'Class Info': {
    en: 'Class Info',
    ja: 'Class Info',
    et: 'Class Info',
    lt: 'Class Info',
    ch: 'Class Info',
    ph: 'Class Info',
  },
  'Class Sign-up Code': {
    en: 'Class Sign-up Code',
    ja: 'Class Sign-up Code',
    et: 'Class Sign-up Code',
    lt: 'Class Sign-up Code',
    ch: 'Class Sign-up Code',
    ph: 'Class Sign-up Code',
  },
  'Cannot delete the class as it does not exist': {
    en: 'Cannot delete the class as it does not exist',
    ja: 'Cannot delete the class as it does not exist',
    et: 'Cannot delete the class as it does not exist',
    lt: 'Cannot delete the class as it does not exist',
    ch: 'Cannot delete the class as it does not exist',
    ph: 'Cannot delete the class as it does not exist',
  },
  'Delete Class': {
    en: 'Delete Class',
    ja: 'Delete Class',
    et: 'Delete Class',
    lt: 'Delete Class',
    ch: 'Delete Class',
    ph: 'Delete Class',
  },
};
